require('./dealer.tag');
require('./dealer-ctas.tag');
require('./dealer-departments.tag');
require('./dealer-badge.tag');

riot.tag2('dealer-detail', '<div class="dealer-detail {\'is-preferred\': opts.dealer.preferred}"> <div class="dealer-header"> <div class="dealer-index" onclick="{selectDealer}">{opts.dealer.preferred ? 1 : opts.dealer.index}</div> <h2 class="dealer-name acr-secondary-title-5">{opts.dealer.Name}</h2> <div hide="{opts.dealer.IsServiceCenter}" class="dealer-preferred-box is-cursor" onclick="{setPreferred}" i class="{\'dl-icon-preferred-dealer\': !opts.dealer.preferred, \'dl-icon-preferred-dealer-selected\': opts.dealer.preferred}"></i> </div> </div> <div class="dealer-content acr-paragraph-5"> <div class="dealer-directions"> <a href="{directions}" target="_blank" data-tracking="{trackingDataDirection}"> <i class="dl-icon-address"></i> </a> <div class="dealer-box"> <div class="dealer-distance" if="{opts.dealer.DrivingDistanceMiles}">{opts.dealer.DrivingDistanceMiles} {labels.milesText}</div> <a href="{directions}" target="_blank" class="dealer-address" data-tracking="{trackingDataDirection}"> <raw-html content="{fullAddress}"></raw-html> </a> </div> </div> <div class="dealer-phone" if="{opts.dealer.Phone}"> <a href="tel:{formatter.phone(dealer.Phone)}" data-tracking="{trackingDataPhone}"> <i class="dl-icon-phone"></i> </a> <a class="dealer-box" href="tel:{formatter.phone(opts.dealer.Phone)}" data-tracking="{trackingDataPhone}" span>{formatter.phone(opts.dealer.Phone)}</span> </a> </div> </div> <dealer-ctas dealer="{opts.dealer}" view="details"></dealer-ctas> </div> <div class="dealer-detail-box dealer-departments" if="{opts.dealer && opts.dealer.SalesHours.length > 0 || opts.dealer.ServiceHours.length > 0 || opts.dealer.PartsHours.length > 0}"> <dealer-departments dealer="{opts.dealer}" department="ServiceHours" phone="ServicePhone" riot-style="order: {departments.service}"></dealer-departments> <dealer-departments dealer="{opts.dealer}" department="PartsHours" phone="PartsPhone" riot-style="order: {departments.parts}"></dealer-departments> <dealer-departments dealer="{opts.dealer}" department="SalesHours" phone="Phone" riot-style="order: {departments.sales}"></dealer-departments> </div> <div class="dealer-detail-box"> <dealer-badge each="{badgeItem in opts.dealer.Attributes}"></dealer-badge> </div> </div>', '', '', function(opts) {
    var self = this;
    var trackingJSON = require('../../data/tracking-data');
    var mapConstants = require('../../core/constants.js').map;
    var trackingFilled = false;

    this.mixin('bus');

    function openDetail() {
      if (window.innerWidth <= mapConstants.MOBILE_BREAKPOINT) {
        window.scrollTo(0, 0);
      } else {
        self.root.scrollTop = 0;
      }
    }

    function triggerTrackingDataPreferred() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.preferredDealer));
      jsonData.Dealer.selected_dealer_id = self.opts.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.opts.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.opts.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.opts.dealer.Address + ', ' + self.opts.dealer.City;
      jsonData.dynamic_variables[2].search = 'locate dealer details';

      if (self.opts.dealer.preferred) {
        jsonData.dynamic_variables[0].search += 'dealer details:deselect preferred dealer';
      } else {
        jsonData.dynamic_variables[0].search += 'dealer details:select preferred dealer';
      }
      if (window.Acr.TrackingManager) {
        window.Acr.TrackingManager.clickActivity(jsonData);
      }
    }

    function setPreferred() {
      triggerTrackingDataPreferred();
      if (!self.opts.dealer.preferred) {
        self.bus.trigger(self.bus.EVENTS.DEALERS.SET_PREFERRED,
          {
            DealerNumber: self.opts.dealer.DealerNumber,
            DealerName: self.opts.dealer.Name,
          });
      } else {
        self.bus.trigger(self.bus.EVENTS.DEALERS.UNSET_PREFERRED);
      }
    }

    this.bus.on(this.bus.EVENTS.DEALERS.OPEN_DETAIL, openDetail);

    function setTrackingDataDirection() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.dealerDirections));
      jsonData.Dealer.selected_dealer_id = self.opts.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.opts.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.opts.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.opts.dealer.Address + ', ' + self.opts.dealer.City;
      jsonData.dynamic_variables[0].search += 'dealer details:[selected_dealer_name]:directions';
      jsonData.dynamic_variables[2].search = 'locate dealer details';

      self.trackingDataDirection = JSON.stringify(jsonData);
    }

    function setTrackingDataPhone() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.dealerTelephone));
      jsonData.Dealer.selected_dealer_id = self.opts.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.opts.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.opts.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.opts.dealer.Address + ', ' + self.opts.dealer.City;
      jsonData.Dealer.selected_dealer_phone_number = self.opts.dealer.Phone;
      jsonData.dynamic_variables[0].search += 'dealer details:call [selected_dealer_name]';
      jsonData.dynamic_variables[2].search = 'locate dealer details';

      self.trackingDataPhone = JSON.stringify(jsonData);
    }

    this.on('update', function onUpate() {
      var thumbBadges = [];
      var noThumbBadges = [];
      if (self.opts.dealer) {
        self.fullAddress = `${self.opts.dealer.Address}</br> ${self.opts.dealer.City}, ${self.opts.dealer.State} ${self.opts.dealer.ZipCode.slice(0, 5)}`;
        self.directions = self.labels.bingMapsDirections
                          + self.fullAddress.replace('</br>', '').replace(/[ ]/g, '%20');

        // Reordering Attributes in order to show first those who have IconUrl
        thumbBadges = self.opts.dealer.Attributes.filter(function filterBadges(attribute) {
          return attribute.IconUrl;
        });
        noThumbBadges = self.opts.dealer.Attributes.filter(function filterBadges(attribute) {
          return !attribute.IconUrl;
        });

        self.opts.dealer.Attributes = thumbBadges.concat(noThumbBadges);

        if (!trackingFilled) {
          setTrackingDataPhone();
          setTrackingDataDirection();
          trackingFilled = true;
        }
      }
    });
    self.setPreferred = setPreferred;
});
